import { c as _c } from "react/compiler-runtime";
import { UserPageTabType } from "@/components/user/layout/UserPageTabs";
import CommonProfileLink from "@/components/user/utils/CommonProfileLink";
import { ProfileActivityLog } from "@/entities/IProfile";
import { ProfileActivityLogType, RateMatter } from "@/enums";
import ProfileActivityLogItemTimeAgo from "./ProfileActivityLogItemTimeAgo";
export default function ProfileActivityLogItemWrapper(t0) {
  const $ = _c(21);
  const {
    log,
    children,
    user
  } = t0;
  const isArchived = log.type === ProfileActivityLogType.PROFILE_ARCHIVED;
  let t1;
  if ($[0] !== log.profile_handle || $[1] !== log.proxy_handle || $[2] !== user) {
    t1 = () => {
      if (!user || !log.proxy_handle) {
        return log?.profile_handle ?? "";
      }
      if (user.toLowerCase() === log.proxy_handle.toLowerCase()) {
        return log.proxy_handle;
      }
      return log.profile_handle ?? "";
    };
    $[0] = log.profile_handle;
    $[1] = log.proxy_handle;
    $[2] = user;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const getHandleOrWallet = t1;
  let handleOrWallet;
  let t2;
  if ($[4] !== getHandleOrWallet || $[5] !== user) {
    handleOrWallet = getHandleOrWallet();
    t2 = user?.toLowerCase() === handleOrWallet.toLowerCase() || !user;
    $[4] = getHandleOrWallet;
    $[5] = user;
    $[6] = handleOrWallet;
    $[7] = t2;
  } else {
    handleOrWallet = $[6];
    t2 = $[7];
  }
  const isCurrentUser = t2;
  const tabTarget = log.type === ProfileActivityLogType.RATING_EDIT && log.contents.rating_matter === RateMatter.REP ? UserPageTabType.REP : UserPageTabType.IDENTITY;
  let t3;
  if ($[8] !== handleOrWallet || $[9] !== isArchived || $[10] !== isCurrentUser || $[11] !== tabTarget) {
    t3 = !isArchived && <CommonProfileLink handleOrWallet={handleOrWallet} isCurrentUser={isCurrentUser} tabTarget={tabTarget} />;
    $[8] = handleOrWallet;
    $[9] = isArchived;
    $[10] = isCurrentUser;
    $[11] = tabTarget;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== children || $[14] !== t3) {
    t4 = <td className="tw-py-2.5"><span className="tw-space-x-1.5 tw-inline-flex tw-items-center">{t3}{children}</span></td>;
    $[13] = children;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== log) {
    t5 = <td className="tw-py-2.5 tw-pl-3 tw-text-right"><ProfileActivityLogItemTimeAgo log={log} /></td>;
    $[16] = log;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== t4 || $[19] !== t5) {
    t6 = <tr className="tw-flex tw-items-center tw-justify-between">{t4}{t5}</tr>;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
}